import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import StartYourAccessibilityJourney from "./sections/StartYourAccessibilityJourney";
import OurStores from "./sections/OurStores";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <StartYourAccessibilityJourney />
      <OurStores />
      <Footer />
    </div>;
}